// babel: push notifications in the Android app. The bridge sends them (Firebase Cloud Messaging) to phones that
// register here after sign-in; the text is already in the reader's language. In a browser nothing happens.

const TOKEN_KEY = 'babel-push-token';

function nativePush() {
  const cap = window.Capacitor;
  if (!cap || !cap.isNativePlatform || !cap.isNativePlatform()) {
    return null;
  }
  return (cap.Plugins && cap.Plugins.PushNotifications) || null;
}

function authHeaders(tinode) {
  const token = tinode.getAuthToken();
  return {'Authorization': 'Bearer ' + (token && token.token), 'Content-Type': 'application/json'};
}

// Ask for permission, create the notification channel, register with Firebase and hand the token to the bridge.
export async function babelRegisterPush(tinode) {
  const Push = nativePush();
  // The app tells us whether Firebase is configured; without it the plugin would crash the whole app.
  if (!Push || localStorage.getItem('babel-push-available') !== '1') {
    return;
  }
  try {
    let perm = await Push.checkPermissions();
    if (perm.receive === 'prompt' || perm.receive === 'prompt-with-rationale') {
      perm = await Push.requestPermissions();
    }
    if (perm.receive !== 'granted') {
      return;
    }
    await Push.createChannel({id: 'messages', name: 'Messages', description: 'New chat messages', importance: 5, visibility: 0})
      .catch(() => {});
    await Push.removeAllListeners();
    Push.addListener('registration', t => {
      localStorage.setItem(TOKEN_KEY, t.value);
      fetch('babel/v1/devices', {method: 'POST', headers: authHeaders(tinode),
        body: JSON.stringify({token: t.value, platform: 'android'})}).catch(() => {});
    });
    Push.addListener('registrationError', e => console.warn('push registration failed', e));
    // In the foreground the chat is live over the connection: nothing to show. A tap on a notification opens its chat.
    Push.addListener('pushNotificationActionPerformed', a => {
      const data = a && a.notification && a.notification.data;
      if (data && data.topic) {
        window.location.hash = '#/' + data.topic;
      }
    });
    await Push.register();
  } catch (e) {
    console.warn('push setup failed', e); // e.g. the app was built without Firebase: chat works, just no notifications
  }
}

// On sign-out: stop notifications for this phone.
export function babelUnregisterPush(tinode) {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) {
    return;
  }
  localStorage.removeItem(TOKEN_KEY);
  fetch('babel/v1/devices', {method: 'DELETE', headers: authHeaders(tinode), body: JSON.stringify({token: token})})
    .catch(() => {});
}
